module.exports = __webpack_public_path__ + "static/media/flame-red.833bec4d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/images/flame-red.svg
// module id = 109
// module chunks = 19